/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */
import { Box } from '@mui/material';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { postHomesaleInfo, updateHomesaleInfo } from 'modules/authorizations/store/actions/homesale.actions';
import { showToast } from 'modules/layout/layout.actions';
import EditableCard from 'modules/common/editableCard.component';
import React from 'react';
import { getHomesaleInfo } from 'modules/authorizations/authorizations.actions';
import { isIdEqual } from 'modules/enumerations/enumerationHelpers';

const ORIGINAL_LISTING_TYPE_TITLE = 'Origlist';

const PropertyInfoCard = props => {
  const { listingInfo, homesaleInfo, enumerations } = props;

  const tabs = [{ header: 'Listing Info', order: 1, iconPath: ['fas', 'money-bill-transfer'] }];

  const originalListingTypeId = (enumerations?.allEnums?.listingTypes || []).find(type => type.title === ORIGINAL_LISTING_TYPE_TITLE)?.id;
  const originalListing = originalListingTypeId
    ? (homesaleInfo?.listings || []).find(listing => isIdEqual(listing.listingTypeId, originalListingTypeId))
    : null;

  // The most recent listing is the one with the highest homesaleListingId.
  const latestListing = (homesaleInfo?.listings || []).reduce(
    (latest, listing) => (!latest || Number(listing.homesaleListingId) > Number(latest.homesaleListingId) ? listing : latest),
    null
  );

  const summaries = [
    { header: 'Broker', accessorKey: 'broker', type: 'text', required: false, value: listingInfo ? listingInfo.brokerName : null, tab: 1 },
    { header: 'BMA Average', accessorKey: 'bmaAverage', type: 'money', required: false, value: null, tab: 1 },
    {
      header: 'Listing Price',
      accessorKey: 'listingPrice',
      type: 'money',
      required: false,
      value: latestListing ? latestListing.listPrice : '',
      tab: 1
    },
    {
      header: 'Original List',
      accessorKey: 'originalListDate',
      type: 'date',
      required: false,
      value: originalListing ? originalListing.listBegins : '',
      tab: 1
    },
    {
      header: 'Referral',
      accessorKey: 'referralDate',
      type: 'money',
      required: false,
      value: listingInfo ? listingInfo.actualReferralFeeReceived : '',
      tab: 1
    },
    {
      header: 'Listing Signed',
      accessorKey: 'listingDate',
      type: 'date',
      required: false,
      value: listingInfo ? listingInfo.listDate : false,
      tab: 1
    },
    {
      header: 'Original List Price',
      accessorKey: 'originalListPrice',
      type: 'money',
      required: false,
      value: originalListing ? originalListing.listPrice : '',
      tab: 1
    }
  ];

  const ListingInfoButtons = ({ ...rest }) => {
    return (
      <>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '0 10px'
              }}
            ></Box>
          </Box>
        </Box>
      </>
    );
  };

  return <EditableCard tabs={tabs} summaries={summaries} numColumns={3} ButtonComponent={ListingInfoButtons} hideEdit={true} />;
};

export default compose(
  connect(null, {
    updateHomesaleInfo,
    postHomesaleInfo,
    showToast,
    getHomesaleInfo
  })
)(PropertyInfoCard);
